<script>
  import { session } from "/@lib/tastyworks-rest"
  import { Tooltip } from "@tastyworks/ui-library"

  function handleSignOut() {
    session.clear()
    window.location.replace(`/login.html`)
  }
</script>

<div class="flex h-[60px] items-center justify-end bg-trade-desk-gray-light">
  <Tooltip.Root>
    <Tooltip.Trigger>
      <p class="mr-2 text-sm">{sessionStorage.getItem("regulatoryDomains")}</p>
    </Tooltip.Trigger>
    <Tooltip.Content>Regulatory Domain</Tooltip.Content>
  </Tooltip.Root>

  <button
    class="min-w-fit cursor-pointer rounded bg-red-500 px-3 py-1 text-white"
    onclick={handleSignOut}>Sign Out</button
  >
</div>
